import Page from 'components/layout/Page';
import HeadMetadata from 'components/shared/HeadMetadata';
import { useI18n } from 'hooks/useI18n';
import { ManfreditesStats } from 'model/manfredites-stats/model.manfredites-stats';
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import { APP_URLS } from 'utils/app-urls';
import { getPublicPath } from 'utils/paths';
import { YourOfferSalaryPageProps } from './YourOfferSalaryPage.types';
import { YourOfferSalaryCta } from './cta/YourOfferSalaryCta';
import YourOfferSalaryFormContact from './form-contact/YourOfferSalaryFormContact';
import { YourOfferSalaryForm } from './form/YourOfferSalaryForm';
import { YourOfferSalaryResults } from './results/YourOfferSalaryResults';

export const YourOfferSalaryPage: React.FC<YourOfferSalaryPageProps> = ({
  roles,
  techs,
  yearsOfExperience
}) => {
  const { t } = useI18n('your-offer-salary');
  const { query } = useRouter();

  const resultsRef = useRef<HTMLDivElement>(null);
  const [result, setResult] = useState<ManfreditesStats | null>(null);
  const [experienceRange, setExperienceRange] = useState<string | null>(null);

  const onSuccess = (data: ManfreditesStats, experienceRange: string): void => {
    setExperienceRange(experienceRange);
    setResult(data);
    if (resultsRef.current) {
      resultsRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  useEffect(() => {
    if (resultsRef.current && !!result) {
      resultsRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }, [query.shared, result]);

  return (
    <>
      <HeadMetadata
        title={t('your-offer-salary.page_title')}
        desc={t('your-offer-salary.page_description')}
        url={APP_URLS.companies}
        imgUrl={`${getPublicPath('/images/cards/card_your_offer_salary.webp')}`}
      />
      <Page hasScrollTop pageVariant="your_salary_offer">
        <YourOfferSalaryForm
          roles={roles}
          techs={techs}
          yearsOfExperience={yearsOfExperience}
          onSuccess={onSuccess}
        />

        <div ref={resultsRef}>
          {!!result && experienceRange && (
            <YourOfferSalaryResults
              data={result}
              experienceRange={experienceRange}
            />
          )}
          {!!result && <YourOfferSalaryCta data={result} />}
          {!!result && <YourOfferSalaryFormContact data={result} />}
        </div>
      </Page>
    </>
  );
};
